import room1 from "./images/details-1.jpeg";
import room2 from "./images/details-2.jpeg";
import room3 from "./images/details-3.jpeg";
import room4 from "./images/details-4.jpeg";
import img1 from "./images/room-1.jpeg";
import img2 from "./images/room-2.jpeg";
import img3 from "./images/room-3.jpeg";
import img4 from "./images/room-4.jpeg";
import img5 from "./images/room-5.jpeg";
import img6 from "./images/room-6.jpeg";
import img7 from "./images/room-7.jpeg";
import img8 from "./images/room-8.jpeg";
import img9 from "./images/room-9.jpeg";
import img10 from "./images/room-10.jpeg";
import img11 from "./images/room-11.jpeg";
import img12 from "./images/room-12.jpeg";

const data = [
  {
    sys: {
      id: "1"
    },
    fields: {
      name: "solteiro economico",
      slug: "solteiro-economico",
      type: "solteiro",
      price: 100,
      size: 200,
      capacity: 1,
      pets: false,
      breakfast: false,
      featured: false,
      description:
      "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Internet",
      ],
      images: [
        {
          fields: {
            file: {
              url: img1
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "2"
    },
    fields: {
      name: "solteiro basico",
      slug: "solteiro-basico",
      type: "solteiro",
      price: 150,
      size: 250,
      capacity: 1,
      pets: false,
      breakfast: false,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Internet"
      ],
      images: [
        {
          fields: {
            file: {
              url: img2
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "3"
    },
    fields: {
      name: "solteiro standard",
      slug: "solteiro-standard",
      type: "solteiro",
      price: 250,
      size: 300,
      capacity: 1,
      pets: true,
      breakfast: false,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
      ],
      images: [
        {
          fields: {
            file: {
              url: img3
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "4"
    },
    fields: {
      name: "solterio deluxe",
      slug: "solterio-deluxe",
      type: "solteiro",
      price: 300,
      size: 400,
      capacity: 1,
      pets: true,
      breakfast: true,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
        "Copos"
      ],
      images: [
        {
          fields: {
            file: {
              url: img4
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "5"
    },
    fields: {
      name: "duplo economico",
      slug: "duplo-economico",
      type: "duplo",
      price: 200,
      size: 300,
      capacity: 2,
      pets: false,
      breakfast: false,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Internet"
      ],
      images: [
        {
          fields: {
            file: {
              url: img5
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "6"
    },
    fields: {
      name: "duplo basico",
      slug: "duplo-basico",
      type: "duplo",
      price: 250,
      size: 350,
      capacity: 2,
      pets: false,
      breakfast: false,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet"
      ],
      images: [
        {
          fields: {
            file: {
              url: img6
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "7"
    },
    fields: {
      name: "duplo standard",
      slug: "duplo-standard",
      type: "doble",
      price: 300,
      size: 400,
      capacity: 2,
      pets: true,
      breakfast: false,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
        "Copos"
      ],
      images: [
        {
          fields: {
            file: {
              url: img7
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "8"
    },
    fields: {
      name: "duplo deluxe",
      slug: "duplo-deluxe",
      type: "doble",
      price: 400,
      size: 500,
      capacity: 2,
      pets: true,
      breakfast: true,
      featured: true,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
        "Copos"
      ],
      images: [
        {
          fields: {
            file: {
              url: img8
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "9"
    },
    fields: {
      name: "familar economico",
      slug: "familar-economico",
      type: "familiar",
      price: 300,
      size: 500,
      capacity: 3,
      pets: false,
      breakfast: false,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
        "Copos"
      ],
      images: [
        {
          fields: {
            file: {
              url: img9
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "10"
    },
    fields: {
      name: "familiar basico",
      slug: "familiar-basic0",
      type: "familiar",
      price: 350,
      size: 550,
      capacity: 4,
      pets: false,
      breakfast: false,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
        "Copos"
      ],
      images: [
        {
          fields: {
            file: {
              url: img10
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "11"
    },
    fields: {
      name: "familar standard",
      slug: "família standard",
      type: "familiar",
      price: 400,
      size: 600,
      capacity: 5,
      pets: true,
      breakfast: false,
      featured: false,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
        "Copos"
      ],
      images: [
        {
          fields: {
            file: {
              url: img11
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "12"
    },
    fields: {
      name: "família deluxe",
      slug: "família-deluxe",
      type: "familiar",
      price: 500,
      size: 700,
      capacity: 6,
      pets: true,
      breakfast: true,
      featured: true,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
        "Copos",
        "Cozinha"
      ],
      images: [
        {
          fields: {
            file: {
              url: img12
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  },
  {
    sys: {
      id: "13"
    },
    fields: {
      name: "presidencial",
      slug: "quarto presidencial",
      type: "presidencial",
      price: 600,
      size: 1000,
      capacity: 10,
      pets: true,
      breakfast: true,
      featured: true,
      description:
        "Arte de rua edison bulbo sem glúten, tofu try-hard lumbersexual brooklyn tatuado em pickled chambray. Na verdade humblebrag próximo nível, deep v art party wolf tofu comércio direto readymade sustentável inferno de banjo. Orgânico autêntico metrô telha clichê palo santo, street art XOXO dreamcatcher retro sriracha portland air plant kitsch stumptown. Austin pequeno lote lula gastropub. Pabst pug tumblr gochujang miudezas retro nuvem pão bushwick semiótica antes de esgotar o sartorial literalmente mlkshk. Vaporware hashtag vice, sartorial antes de esgotar o pok pok health goth trust fund cray.",
      extras: [
        "Frigorífico",
        "Televisão de Ecrã Plano / Plasma / LCD",
        "Secador de cabelo",
        "Micro-ondas",
        "Cofre",
        "Internet",
        "Copos",
        "Cozinha",
        "Comando por tv"
      ],
      images: [
        {
          fields: {
            file: {
              url: room1
            }
          }
        },
        {
          fields: {
            file: {
              url: room2
            }
          }
        },
        {
          fields: {
            file: {
              url: room3
            }
          }
        },
        {
          fields: {
            file: {
              url: room4
            }
          }
        }
      ]
    }
  }
];
export default data;